import { assert } from '@varos/util-typescript';
import { IntegrationLoaderBaseConfig } from '../../../base';
import { ThreadNewLoader } from './integrationNewInterface';
import { ThreadNewAggregate } from './integrationNewModel';
import { useMemo } from 'react';

export function createThreadNewLoader(
    config: IntegrationLoaderBaseConfig
): ThreadNewLoader {
    const { repository } = config;
    return {
        useLoad(context, props): ThreadNewAggregate {
            const integrationQuery = repository.platform.integration.useRetrieve(
                context,
                props.integration.id,
                {
                    suspense: true,
                }
            );
            assert(integrationQuery.status === 'success', 'expected suspense');
            const definitionQuery = repository.platform.integrationDefinition.useRetrieve(
                context,
                integrationQuery.data.definition_id,
                {
                    suspense: true,
                }
            );
            assert(definitionQuery.status === 'success', 'expected suspense');

            const toolsQuery = repository.platform.integrationTool.useFind(
                context,
                {
                    integrationDefinitionId: definitionQuery.data.id,
                },
                { suspense: true }
            );

            assert(toolsQuery.status === 'success', 'expected suspense');

            const tool = useMemo(() => {
                return toolsQuery.data.find((tool) => tool.id === props.tool?.id) ?? null;
            }, [toolsQuery.data, props.tool]);

            return {
                integration: integrationQuery.data,
                definition: definitionQuery.data,
                tool,
                // thread: {
                //     thread: null,
                //     messages: [],
                //     integration: integrationQuery.data,
                //     definition: definitionQuery.data,
                // },
            };
        },
    };
}
